import http from '@services/http'
import {
  IMatchupClub,
  IBet,
  IUpdateMatchupItems,
  IJoinClub,
  IMajorTournamentFilters,
  IBinGameRecord,
  IBinBet,
  ICashShopInfo,
  IMatchupDetailFilters,
  IGlobalSettings,
  IMatchupTracks,
  IMatchupDetailMarkets,
  Schema$ServerCheck,
  IBettingCancel,
  IFavoriteMatch,
  IFavoriteMarket,
  IFavoriteMarkets,
  IMarketProvider,
  IFavoriteMatchList,
  IMatchupDetailPackage,
} from '@protocol/game'
import { GAME_TYPE } from '@game-type/game-market-types'
import { Schema$ResponseBase } from '@v2/interface/common'

export default {
  getMatchupClub(data: IMatchupClub.Params): Promise<IMatchupClub.Schema> {
    return http.post('game/matchupClub', data || {})
  },
  getMajorTournamentFilters(data: IMajorTournamentFilters.Params): Promise<IMajorTournamentFilters.Schema> {
    return http.get('game/majorTournamentFilters', data || {})
  },
  doBet(data: IBet.Params): Promise<IBet.Schema> {
    return http.post('game/bet', data || {})
  },
  doliveBet(data: IBet.Params): Promise<IBet.Schema> {
    return http.post('game/liveBet', data || {})
  },
  doliveBetCancel(): Promise<Schema$ResponseBase> {
    return http.post('game/liveBetCancel', {})
  },
  doSpecialBet(data: IBinBet.Params): Promise<IBinBet.Schema> {
    return http.post('game/binBet', data || {})
  },
  doMixBet(data: IBet.Params): Promise<IBet.Schema> {
    return http.post('game/mixBet', data || {})
  },
  getUpdateGame(data: IUpdateMatchupItems.Params): Promise<IUpdateMatchupItems.Schema> {
    return http.post('game/update', data || {})
  },

  getGameTournamentTracks(data: IMatchupTracks.Params): Promise<IMatchupTracks.Schema> {
    if (data.gameType !== GAME_TYPE.LIVE && data.limit > 20) {
      data.limit = 20
    }
    return http.get('game/tournamentTracks', data || {})
  },

  joinClub(data: IJoinClub.Params): Promise<IJoinClub.Schema> {
    return http.post('game/joinClub', data || {})
  },

  getBinGameRecord(data: IBinGameRecord.Params): Promise<IBinGameRecord.Schema> {
    return http.post('game/binGameRecord', data || {})
  },

  getCashShopInfo(): Promise<ICashShopInfo.Schema> {
    return http.get('game/getCashShopInfo', {})
  },

  getMatchupDetailFilters(data: IMatchupDetailFilters.Params): Promise<IMatchupDetailFilters.Schema> {
    return http.post('game/matchupDetailFilters', data || {})
  },

  getMatchupDetailMarkets(data: IMatchupDetailMarkets.Params): Promise<IMatchupDetailMarkets.Schema> {
    return http.get('game/matchupDetailMarkets', data || {})
  },

  getGlobalSettings(): Promise<IGlobalSettings.Schema> {
    return http.get('game/getGlobalSettings', {})
  },

  getServerCheck(): Promise<Schema$ServerCheck> {
    return http.get('game/serverCheck', {})
  },

  doCancelBet(data: IBettingCancel.Params): Promise<IBettingCancel.Schema> {
    return http.post('game/cancelBet', data || {})
  },

  toggleFavoriteMatch(data: IFavoriteMatch.Params): Promise<IFavoriteMatch.Schema> {
    return http.post('game/toggleFavoriteMatch', data || {})
  },

  toggleFavoriteMatchList(data: IFavoriteMatchList.Params): Promise<IFavoriteMatchList.Schema> {
    return http.post('game/toggleFavoriteMatchList', data || {})
  },

  toggleFavoriteMarket(data: IFavoriteMarket.Params): Promise<IFavoriteMarket.Schema> {
    return http.post('game/toggleFavoriteMarket', data || {})
  },

  favoriteMarkets(data: IFavoriteMarkets.Params): Promise<IFavoriteMarkets.Schema> {
    return http.post('game/favoriteMarkets', data || {})
  },

  /**
   * 20초 마다 마켓프로바이더를 호출한다.
   * 대부분은 클라이언트에 전달된 글로벌값이나 토너먼트 트랙 호출시 함께 전달되는 값으로 충분하지만
   * 간혹 클라이언트 새로고침을 하지 않아 이전 데이터를 계속 바라보는 경우가 있어 추가함.
   */
  getMarketProvider(): Promise<IMarketProvider.Schema> {
    return http.get('game/marketProvider', {})
  },

  fetchFavoriteMatchCount(): Promise<{ favoriteMatchCount: number }> {
    return http.get('game/fetchFavoriteMatchCount', {})
  },

  getMatchupDetailPackage(data: IMatchupDetailPackage.Params): Promise<IMatchupDetailPackage.Schema> {
    return http.get('game/getMatchupDetailPackage', data)
  },
}
